import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(({ spacing, palette }) => ({
  toLabel: {
    color: palette.primary.main,
    fontWeight: 800,
    fontStyle: "italic",
    margin: `0 ${spacing()}px`,
  },
  label: {
    fontSize: 14,
  },
}));

export default useStyles;
